import omniSubcategories from './reducers';

import * as omniSubcategoriesOperations from './operations';
import * as omniSubcategoriesTypes from './types';
import * as omniSubcategoriesAction from './actions';

export { omniSubcategoriesOperations, omniSubcategoriesTypes, omniSubcategoriesAction };

export default omniSubcategories;
